import type { GlucosePercentageAboveInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import { TilePercentage } from "./TilePercentage"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"

export function GlucosePercentageAbove(props: TileProps<GlucosePercentageAboveInsight>) {
  const {
    insightKey,
    range,
  } = props

  const { glucoseCalculations } = useCalculationsContext()
  const { percentAboveNormal } = glucoseCalculations[range] || {}

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TilePercentage
        percentage={percentAboveNormal}
        insightKey={insightKey}
      />
    </>
  )
}
